import { useEffect, useState } from 'react';
// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead,
  Button,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';
import plusFill from '@iconify/icons-eva/plus-fill';
import personRemoveFill from '@iconify/icons-eva/person-remove-fill';
import { Link as RouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Icon } from '@iconify/react';
import * as React from 'react';
import { LoadingButton } from '@mui/lab';
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import { Loading } from '../components/Loading';
import { fUserRole } from '../utils/formatEnums';
import NewMemberDialog from '../components/_dashboard/member/NewMemberDialog';

const PropertyMembers = ({
  fetchMembersByPropertyId,
  members,
  isLoading,
  selectedProperty,
  removeMember,
  removeMemberStatus,
  currentRole
}) => {
  const [newMemberDialogOpen, setNewMemberDialogOpen] = useState(false);
  useEffect(() => {
    if (selectedProperty) {
      fetchMembersByPropertyId(selectedProperty.id);
    }
  }, [selectedProperty]);

  if (isLoading) {
    return <Loading />;
  }

  console.log({ removeMemberStatus });

  return (
    <Page title="Miembros de propiedad | Chapapp">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Miembros de propiedad
          </Typography>
          {currentRole && currentRole === 'admin' && (
            <>
              <Button
                onClick={() => setNewMemberDialogOpen(true)}
                variant="contained"
                component={RouterLink}
                to="#"
                startIcon={<Icon icon={plusFill} />}
              >
                Agregar miembro
              </Button>
              <NewMemberDialog open={newMemberDialogOpen} setOpen={setNewMemberDialogOpen} />
            </>
          )}
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="normal" align="left">
                      Nombre
                    </TableCell>
                    <TableCell align="left">Email</TableCell>
                    <TableCell align="left">Rol</TableCell>
                    <TableCell align="left">Dpto</TableCell>
                    <TableCell align="left">Tiene chapa</TableCell>
                    {currentRole && currentRole === 'admin' && (
                      <TableCell align="left">Acción</TableCell>
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {members &&
                    members.map((row) => {
                      const { type, name, id, email, dptoNumber, userHasChapa } = row;
                      return (
                        <TableRow hover key={id} tabIndex={-1} role="checkbox">
                          <TableCell align="left">{name}</TableCell>
                          <TableCell align="left">{email}</TableCell>
                          <TableCell align="left">
                            <Label variant="ghost">{fUserRole(type)}</Label>
                          </TableCell>
                          <TableCell align="left">{dptoNumber}</TableCell>
                          <TableCell align="left">{userHasChapa ? 'Si' : 'No'}</TableCell>
                          {currentRole && currentRole === 'admin' && (
                            <TableCell align="left">
                              <LoadingButton
                                loading={removeMemberStatus.loading}
                                onClick={() => removeMember(id)}
                                color="error"
                                variant="contained"
                                component={RouterLink}
                                to="#"
                                startIcon={<Icon icon={personRemoveFill} />}
                              />
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>
    </Page>
  );
};

const mapState = (state) => ({
  members: state.property.members,
  currentRole: state.property.currentRole,
  isLoading: state.loading.effects.property.fetchMembersByPropertyId.loading,
  removeMemberStatus: state.loading.effects.property.removeMember,
  selectedProperty: state.property.selectedProperty
});

const mapDispatch = (dispatch) => ({
  fetchMembersByPropertyId: dispatch.property.fetchMembersByPropertyId,
  removeMember: dispatch.property.removeMember
});

export default connect(mapState, mapDispatch)(PropertyMembers);
